import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { IdentityDetails } from '../../../../../../consumer/graphql/fragments/identity';
import {
  IdentityAlbumFolderTagBaseDetails,
  IdentityAlbumFolderUniformTagDetails,
} from '../../../../../../../graphql/fragments/identity';

export const getIdentityAlbumFolderTagsQuery = gql`
  query getIdentityAlbumFolderTags(
    $identityId: RecordID!
    $albumFolderId: RecordID!
  ) {
    identity(id: $identityId) {
      id
      ...IdentityDetails
      album_folder_tags(
        slice: { limit: 999 }
        album_folder_id: $albumFolderId
      ) {
        records {
          id
          ...IdentityAlbumFolderTagBaseDetails
          ...IdentityAlbumFolderUniformTagDetails
        }
      }
    }
  }
  ${IdentityDetails}
  ${IdentityAlbumFolderTagBaseDetails}
  ${IdentityAlbumFolderUniformTagDetails}
`;

export const getIdentityAlbumFolderTagsOptions = {
  options: ({ identityId, albumFolderId }) => ({
    variables: {
      identityId,
      albumFolderId,
    },
    fetchPolicy: 'network-only',
  }),
  skip: ({ identityId, albumFolderId }) => !identityId || !albumFolderId,
};

const getIdentityAlbumFolderTags = graphql(
  getIdentityAlbumFolderTagsQuery,
  getIdentityAlbumFolderTagsOptions,
);

export default getIdentityAlbumFolderTags;
